import { useMemo } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'

import { OutletWrapper, Search } from '@base'
import { Tabs as TabsV2, Button as ButtonV2 } from '@baseV2'
import { useForceUpdate } from '@hooks'
import { AdminManageLogisticsNavigationWrapper, SearchWrapper } from './styles'
import { DRAWER_TYPES, searchFilter, strings } from '@constants'
import { removeTrailingSlash } from '@utils'
import { paths } from '@routes'
import { Add } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { toggleDrawer } from '@data/state/action/root'

const AdminLogisticsQuote = () => {
	const globalDispatch = useDispatch()
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const [forceUpdate, update] = useForceUpdate()
	const isLogisticsPrice = pathname.includes('price')
	const isAllTab = removeTrailingSlash(pathname) === paths.admin_logistics_quote_all

	const hideTabs = pathname.includes('edit') || pathname.includes('create')

	const tabs = useMemo(() => {
		const currentPath = removeTrailingSlash(pathname)
		return [
			{
				label: strings('all'),
				selected: currentPath === paths.admin_logistics_quote_all,
				onClick: () => navigate(paths.admin_logistics_quote_all),
			},
			{
				label: strings('active'),
				selected: currentPath === paths.admin_logistics_quote_active,
				onClick: () => navigate(paths.admin_logistics_quote_active),
			},
			{
				label: strings('order_placed'),
				selected: currentPath === paths.admin_logistics_quote_order_placed,
				onClick: () => navigate(paths.admin_logistics_quote_order_placed),
			},
			{
				label: strings('logistics_price'),
				selected: currentPath === paths.admin_logistics_price,
				onClick: () => navigate(paths.admin_logistics_price),
			},
		]
	}, [pathname, navigate])

	const openAddLogisticPrice = () => {
		globalDispatch(toggleDrawer(true, DRAWER_TYPES.LOGISTICS_ADD_PRICE, { update }))
	}

	const searchHandler = () => {
		globalDispatch(toggleDrawer(true, DRAWER_TYPES.OPEN_SEARCH_PANEL, { searchType: searchFilter.LOGISTICS_SEARCH }))
	}

	return (
		<>
			{!hideTabs && (
				<AdminManageLogisticsNavigationWrapper>
					<TabsV2 data={tabs} />

					<SearchWrapper>
						{isLogisticsPrice && (
							<ButtonV2 color='primary' iconPrefix={<Add fontSize='small' />} onClick={openAddLogisticPrice}>
								{strings('add')}
							</ButtonV2>
						)}

						{isAllTab && (
							<SearchWrapper>
								<Search clickHandler={searchHandler} />
							</SearchWrapper>
						)}
					</SearchWrapper>
				</AdminManageLogisticsNavigationWrapper>
			)}
			<OutletWrapper>
				<Outlet context={[forceUpdate, update]} />
			</OutletWrapper>
		</>
	)
}

export default AdminLogisticsQuote
